import { Skeleton } from 'antd';

/**
 * ScheduleTab uchun skeleton: availability card, haftalik jadval,
 * dam olish kunlari va istisnolar.
 */
export default function ScheduleTabSkeleton() {
  return (
    <div key="schedule-skeleton" className="bl-animate-in">
      {/* Availability toggle card */}
      <div
        style={{
          borderRadius: 16,
          background: 'var(--bl-surface, #fff)',
          border: '1px solid var(--bl-divider, #ebebeb)',
          padding: '14px 16px',
          marginBottom: 12,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
          <Skeleton.Avatar active size={38} shape="square" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
            <Skeleton.Input active size="small" style={{ width: 90, height: 15 }} />
            <Skeleton.Input active size="small" style={{ width: 160, height: 12 }} />
          </div>
        </div>
        <Skeleton.Input active size="small" style={{ width: 44, height: 24, borderRadius: 999 }} />
      </div>

      {/* Weekly schedule section */}
      <div style={{ marginBottom: 8 }}>
        <Skeleton.Input active size="small" style={{ width: 140, height: 14 }} />
      </div>

      <div
        style={{
          borderRadius: 16,
          background: 'var(--bl-surface, #fff)',
          border: '1px solid var(--bl-divider, #ebebeb)',
          marginBottom: 12,
          overflow: 'hidden',
        }}
      >
        {[0, 1, 2, 3, 4, 5, 6].map((i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 14px',
              borderBottom: i < 6 ? '1px solid var(--bl-divider, #ebebeb)' : 'none',
              gap: 10,
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <Skeleton.Input active size="small" style={{ width: 86, height: 14 }} />
              <Skeleton.Input active size="small" style={{ width: 100, height: 12 }} />
            </div>
            <Skeleton.Input
              active
              size="small"
              style={{ width: 32, height: 20, borderRadius: 999 }}
            />
          </div>
        ))}
      </div>

      {/* Exceptions section header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 8,
        }}
      >
        <Skeleton.Input active size="small" style={{ width: 120, height: 14 }} />
        <Skeleton.Input active size="small" style={{ width: 90, height: 28, borderRadius: 10 }} />
      </div>

      {/* Exception card */}
      <div
        style={{
          borderRadius: 14,
          background: 'var(--bl-surface, #fff)',
          border: '1px solid var(--bl-divider, #ebebeb)',
          padding: '12px 14px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          marginBottom: 8,
        }}
      >
        <Skeleton.Avatar active size={34} shape="square" />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 5 }}>
          <Skeleton.Input active size="small" style={{ width: 130, height: 14 }} />
          <Skeleton.Input active size="small" style={{ width: 100, height: 12 }} />
        </div>
        <Skeleton.Avatar active size={28} shape="square" />
      </div>
    </div>
  );
}
